import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import FooterSpMenuContent from '@components/layout/Footer/SP/MenuContent';
import FooterNavigation from '@components/layout/Footer/FooterNavigation';
import ContactAndRequestButtons from '@components/layout/Footer/SP/ContactAndRequestButtons';
import SocialMediaIcons from '@components/common/SocialMediaIcons';
import GrayBorder from '@components/common/GrayBorder';
import Copyright from '@components/layout/Footer/Copyright';
import Link from '@mui/material/Link';
import { AppConfigContext } from '@providers/AppConfigProvider';

export default function FooterSP() {
  const { pathRoot, comUrl } = useContext(AppConfigContext);
  const pathLogo: string = `${pathRoot}/assets/images/common/logo.svg`;

  return (
    <>
      <Box className="mx-8">
        <Box className="flex justify-center mb-14">
          <Box>
            <Link href={comUrl} className="flex items-center no-underline">
              <img src={pathLogo} alt="main-logo" className="w-64 h-14" />
            </Link>
          </Box>
        </Box>
        <Box className="flex justify-center mb-14">
          <ContactAndRequestButtons />
        </Box>
        <FooterSpMenuContent />
        <Box className="flex justify-start">
          <SocialMediaIcons color="black" />
        </Box>
      </Box>
      <GrayBorder />
      <Box className="mx-8 mb-8">
        <FooterNavigation />
        <Copyright />
      </Box>
    </>
  );
}
